import { policyConfig } from "shared";

import { fieldIsValid } from "../../../../../lib/helper";
import { CurrencyInput } from "../../../../../../common/Atoms/CurrencyInput";
import { InputTextAddon } from "../../../../../../common/Atoms/InputTextAddon";
import { AccountSelector } from "../AccountSelector";
import { useAccountingSystemTerm } from "../../../../../hooks/useAccountingSystemTerm";
import { TaxSelector } from "../TaxSelector";
import { Transition } from "../../../../../../common/Atoms/Transition";

import { IFieldProps } from "./fieldProps";

const config = policyConfig.fixed_fee_amount;

export function StatementChargeFixedAmount({
  policyFormData,
  invalids,
  handleChange,
}: IFieldProps) {

  return (
    <div className={ `grid grid-cols-12 gap-4` }>
      <div className={ `col-span-4` }>
        <CurrencyInput
          label={ config.label }
          description={ `Apply a fixed fee line item to the late fee. Set to 0 to not add. Uses the contacts, or organisations default currency.` }
          value={ policyFormData.fixed_fee_amount }
          onChange={ handleChange }
          name={ `fixed_fee_amount` }
          invalid={ fieldIsValid(`fixed_fee_amount`, invalids) }
          dataType={ `number` }
        />
      </div>

      <div className={ `col-span-8` }>
        <InputTextAddon
          label={ `Line Item Description` }
          placeholder={ `Fixed Charge` }
          value={ policyFormData.fixed_amount_line_description }
          onChange={ handleChange }
          name={ `fixed_amount_line_description` }
          invalid={ fieldIsValid(`fixed_amount_line_description`, invalids) }
        />
      </div>

      <div className={ `col-span-6` }>
        <AccountSelector
          label={ useAccountingSystemTerm(`Fee Income Account`) }
          value={ policyFormData.fixed_amount_account_code }
          valueKey={ `code` }
          onChange={ handleChange }
          name={ `fixed_amount_account_code` }
          invalid={ fieldIsValid(`fixed_amount_account_code`, invalids) }
          helpIcon={ `Defaults to account set for main interest charges` }
          clearable
        />
      </div>

      <Transition
        speed={ `slow` }
        show={ !!policyFormData.fixed_amount_account_code }
      >
        <div className={ `col-span-6` }>
          <TaxSelector
            label={ useAccountingSystemTerm(`Tax Rate`) }
            code={ policyFormData.fixed_amount_tax_rate }
            onChange={ handleChange }
            name={ `fixed_amount_tax_rate` }
            invalid={ fieldIsValid(`fixed_amount_tax_rate`, invalids) }
          />
        </div>
      </Transition>
    </div>
  );
}
